import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moldSelect", "moldVariantSelect", "wickSelect", "wickVariantSelect"]
  static values = {
    molds: Array,
    moldVariants: Array,
    wicks: Array,
    wickVariants: Array
  }

  connect() {
    // If editing an existing variant, populate the dropdowns
    // We need to do this in the right order: mold variants first, then wick variants
    if (this.hasMoldSelectTarget) {
      const hasMoldSelected = this.moldSelectTarget.value
      if (hasMoldSelected) {
        this.updateMoldVariants()
      }
    }

    if (this.hasWickSelectTarget) {
      const hasWickSelected = this.wickSelectTarget.value
      if (hasWickSelected) {
        this.updateWickVariants()
      }
    }
  }

  updateMoldVariants() {
    const selectedMoldId = parseInt(this.moldSelectTarget.value)
    const moldVariantSelect = this.moldVariantSelectTarget
    const currentValue = moldVariantSelect.value

    // Clear current options
    moldVariantSelect.innerHTML = '<option value="">Sélectionner une variante</option>'

    if (!selectedMoldId) {
      moldVariantSelect.disabled = true
      moldVariantSelect.innerHTML = '<option value="">Sélectionner un moule d\'abord</option>'
      return
    }

    // Filter mold variants by selected mold
    const filteredVariants = this.moldVariantsValue.filter(mv => mv.mold_id === selectedMoldId)

    // Populate mold variant select
    filteredVariants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      moldVariantSelect.appendChild(option)
    })

    moldVariantSelect.disabled = false

    // Auto-select the first variant if there's only one and no current value
    if (filteredVariants.length === 1 && !currentValue) {
      moldVariantSelect.value = filteredVariants[0].id
      // Trigger the change event to auto-fill wick
      this.selectRecommendedWick()
    }
  }

  updateWickVariants() {
    const selectedWickId = parseInt(this.wickSelectTarget.value)
    const wickVariantSelect = this.wickVariantSelectTarget
    const currentValue = wickVariantSelect.value

    // Clear current options
    wickVariantSelect.innerHTML = '<option value="">Sélectionner une variante</option>'

    if (!selectedWickId) {
      wickVariantSelect.disabled = true
      wickVariantSelect.innerHTML = '<option value="">Sélectionner un type de mèche d\'abord</option>'
      return
    }

    // Filter wick variants by selected wick
    const filteredVariants = this.wickVariantsValue.filter(wv => wv.wick_id === selectedWickId)

    // Populate wick variant select
    filteredVariants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      wickVariantSelect.appendChild(option)
    })

    wickVariantSelect.disabled = false

    // Auto-select the first variant if there's only one and no current value
    if (filteredVariants.length === 1 && !currentValue) {
      wickVariantSelect.value = filteredVariants[0].id
    }
  }

  selectRecommendedWick() {
    const selectedMoldVariantId = parseInt(this.moldVariantSelectTarget.value)
    
    if (!selectedMoldVariantId) {
      return
    }

    // Find the selected mold variant
    const moldVariant = this.moldVariantsValue.find(mv => mv.id === selectedMoldVariantId)
    
    if (!moldVariant || !moldVariant.recommended_wick_variant_id) {
      return
    }

    // Find the recommended wick variant
    const recommendedWickVariant = this.wickVariantsValue.find(
      wv => wv.id === moldVariant.recommended_wick_variant_id
    )

    if (!recommendedWickVariant) {
      return
    }

    // Auto-select the wick type
    this.wickSelectTarget.value = recommendedWickVariant.wick_id
    
    // Populate wick variants for this wick type
    this.updateWickVariants()
    
    // Auto-select the recommended wick variant
    this.wickVariantSelectTarget.value = moldVariant.recommended_wick_variant_id
  }
}

